import { render, staticRenderFns } from "./VerificationBadge.vue?vue&type=template&id=06ad2704&scoped=true&"
import script from "./VerificationBadge.vue?vue&type=script&lang=js&"
export * from "./VerificationBadge.vue?vue&type=script&lang=js&"
import style0 from "./VerificationBadge.vue?vue&type=style&index=0&id=06ad2704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad2704",
  null
  
)

export default component.exports